import { Injectable } from "@angular/core";
import { IRulesService } from "@comunicare/comunicare-angular-interfaces";
import { IDataSourceBackendParam, IRule, IRuleListInfo } from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { SessionService } from "../shared/services/session.service";
import { RulesApiService } from "./rules.api";

/**
 * The rules service the rule editor and the rule list read through (RULE_SERVICE injection token).
 *
 * The listing is never scoped by service here: the configurator has no healthcare service, so its rules
 * carry none and "orgsAndServicesRefs" is left out of the requests.
 */
@Injectable({
  providedIn: "root",
})
export class RulesService implements IRulesService {
  constructor(
    private api: RulesApiService,
    private sessionService: SessionService
  ) {}

  public getRule(identifier: string): Observable<IRule> {
    return this.api.getRule(identifier);
  }

  public createRule(rule: IRule): Observable<IRule> {
    return this.api.createRule(rule);
  }

  public updateRule(rule: IRule): Observable<IRule> {
    return this.api.updateRule(rule);
  }

  public deleteRule(identifier: string): Observable<boolean> {
    return this.api.deleteRule(identifier);
  }

  public getRulesInfos(params: IDataSourceBackendParam): Observable<IRuleListInfo[]> {
    return this.api.getRulesInfos(
      params.pageNumber,
      params.pageSize,
      params.search,
      params.sortId,
      params.sortOrder,
      JSON.stringify(params.filters),
      // the careplan names of the scopes are stored as translation keys, resolved by the server
      this.sessionService.userLang
    );
  }

  public getRulesInfosCount(params: IDataSourceBackendParam): Observable<{ count: number }> {
    return this.api.getRulesInfosCount(params.search, JSON.stringify(params.filters));
  }
}
